import { defineNuxtPlugin } from '#app/nuxt'
import { LazyComponents404, LazyComponentsAdditional, LazyComponentsAttractions, LazyComponentsCareer, LazyComponentsContactUs, LazyComponentsDiagonalHeader, LazyComponentsDinings, LazyComponentsEnvironmentalPolicy, LazyComponentsError, LazyComponentsEvents, LazyComponentsFacilities, LazyComponentsFooter, LazyComponentsGeneralTerms, LazyComponentsGeneralTermsSlug, LazyComponentsHeader, LazyComponentsHeroBanner, LazyComponentsHome, LazyComponentsIcon, LazyComponentsLoading, LazyComponentsMeetings, LazyComponentsNotFound, LazyComponentsOffers, LazyComponentsOffersDetail, LazyComponentsPaymentMethods, LazyComponentsPrivacyPolicy, LazyComponentsRooms, LazyComponentsRoomsDetail, LazyComponentsTermNCondition, LazyComponentsWhatsNew, LazyComponentsWhatsNewDetail, LazyComponentsAdditionalClubAccess, LazyComponentsAdditionalGallery, LazyComponentsAdditionalOffers, LazyComponentsAdditionalPackages, LazyComponentsErrorEmpty, LazyComponentsHomeAboutUs, LazyComponentsHomeBrand, LazyComponentsHomeDevider, LazyComponentsHomeFacilities, LazyComponentsHomeGallery, LazyComponentsHomeHero, LazyComponentsHomeOffers, LazyComponentsHomeRooms, LazyComponentsHomeWhatsNew, LazyComponentsLoadingAboutUsSkeleton, LazyComponentsLoadingAttractionsSkeleton, LazyComponentsLoadingDiningsSkeleton, LazyComponentsLoadingEventsSkeleton, LazyComponentsLoadingFacilitiesSkeleton, LazyComponentsLoadingGallerySkeleton, LazyComponentsLoadingMeetingsSkeleton, LazyComponentsLoadingOffersSkeleton, LazyComponentsLoadingRoomsSkeleton, LazyComponentsLoadingWhatsNewSkeleton, LazyComponentsRoomsDetailHero, LazyTailwindConfig } from '#components'
const lazyGlobalComponents = [
  ["Components404", LazyComponents404],
["ComponentsAdditional", LazyComponentsAdditional],
["ComponentsAttractions", LazyComponentsAttractions],
["ComponentsCareer", LazyComponentsCareer],
["ComponentsContactUs", LazyComponentsContactUs],
["ComponentsDiagonalHeader", LazyComponentsDiagonalHeader],
["ComponentsDinings", LazyComponentsDinings],
["ComponentsEnvironmentalPolicy", LazyComponentsEnvironmentalPolicy],
["ComponentsError", LazyComponentsError],
["ComponentsEvents", LazyComponentsEvents],
["ComponentsFacilities", LazyComponentsFacilities],
["ComponentsFooter", LazyComponentsFooter],
["ComponentsGeneralTerms", LazyComponentsGeneralTerms],
["ComponentsGeneralTermsSlug", LazyComponentsGeneralTermsSlug],
["ComponentsHeader", LazyComponentsHeader],
["ComponentsHeroBanner", LazyComponentsHeroBanner],
["ComponentsHome", LazyComponentsHome],
["ComponentsIcon", LazyComponentsIcon],
["ComponentsLoading", LazyComponentsLoading],
["ComponentsMeetings", LazyComponentsMeetings],
["ComponentsNotFound", LazyComponentsNotFound],
["ComponentsOffers", LazyComponentsOffers],
["ComponentsOffersDetail", LazyComponentsOffersDetail],
["ComponentsPaymentMethods", LazyComponentsPaymentMethods],
["ComponentsPrivacyPolicy", LazyComponentsPrivacyPolicy],
["ComponentsRooms", LazyComponentsRooms],
["ComponentsRoomsDetail", LazyComponentsRoomsDetail],
["ComponentsTermNCondition", LazyComponentsTermNCondition],
["ComponentsWhatsNew", LazyComponentsWhatsNew],
["ComponentsWhatsNewDetail", LazyComponentsWhatsNewDetail],
["ComponentsAdditionalClubAccess", LazyComponentsAdditionalClubAccess],
["ComponentsAdditionalGallery", LazyComponentsAdditionalGallery],
["ComponentsAdditionalOffers", LazyComponentsAdditionalOffers],
["ComponentsAdditionalPackages", LazyComponentsAdditionalPackages],
["ComponentsErrorEmpty", LazyComponentsErrorEmpty],
["ComponentsHomeAboutUs", LazyComponentsHomeAboutUs],
["ComponentsHomeBrand", LazyComponentsHomeBrand],
["ComponentsHomeDevider", LazyComponentsHomeDevider],
["ComponentsHomeFacilities", LazyComponentsHomeFacilities],
["ComponentsHomeGallery", LazyComponentsHomeGallery],
["ComponentsHomeHero", LazyComponentsHomeHero],
["ComponentsHomeOffers", LazyComponentsHomeOffers],
["ComponentsHomeRooms", LazyComponentsHomeRooms],
["ComponentsHomeWhatsNew", LazyComponentsHomeWhatsNew],
["ComponentsLoadingAboutUsSkeleton", LazyComponentsLoadingAboutUsSkeleton],
["ComponentsLoadingAttractionsSkeleton", LazyComponentsLoadingAttractionsSkeleton],
["ComponentsLoadingDiningsSkeleton", LazyComponentsLoadingDiningsSkeleton],
["ComponentsLoadingEventsSkeleton", LazyComponentsLoadingEventsSkeleton],
["ComponentsLoadingFacilitiesSkeleton", LazyComponentsLoadingFacilitiesSkeleton],
["ComponentsLoadingGallerySkeleton", LazyComponentsLoadingGallerySkeleton],
["ComponentsLoadingMeetingsSkeleton", LazyComponentsLoadingMeetingsSkeleton],
["ComponentsLoadingOffersSkeleton", LazyComponentsLoadingOffersSkeleton],
["ComponentsLoadingRoomsSkeleton", LazyComponentsLoadingRoomsSkeleton],
["ComponentsLoadingWhatsNewSkeleton", LazyComponentsLoadingWhatsNewSkeleton],
["ComponentsRoomsDetailHero", LazyComponentsRoomsDetailHero],
["TailwindConfig", LazyTailwindConfig],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
